import { render, staticRenderFns } from "./xflist.vue?vue&type=template&id=38a6a883&scoped=true"
import script from "./xflist.vue?vue&type=script&lang=js"
export * from "./xflist.vue?vue&type=script&lang=js"
import style0 from "./xflist.vue?vue&type=style&index=0&id=38a6a883&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6a883",
  null
  
)

export default component.exports